/**
 * Bricksart × PostHog — custom storefront events.
 * Relies on snippets/posthog.liquid for init + window.BricksartPostHog.context.
 */
(function () {
  function ph() {
    return window.posthog;
  }

  function capture(event, properties) {
    var client = ph();
    if (!client || typeof client.capture !== 'function') return;
    var props = properties || {};
    var ctx = (window.BricksartPostHog && window.BricksartPostHog.context) || {};
    if (ctx.template && props.template == null) props.template = ctx.template;
    if (ctx.page_type && props.page_type == null) props.page_type = ctx.page_type;
    if (ctx.currency && props.currency == null) props.currency = ctx.currency;
    client.capture(event, props);
  }

  window.BricksartAnalytics = {
    capture: capture,
  };

  function moneyFromCents(cents) {
    if (cents == null || cents === '') return undefined;
    var n = Number(cents);
    if (!Number.isFinite(n)) return undefined;
    return Math.round(n) / 100;
  }

  function cartSummary(cart) {
    if (!cart) return {};
    return {
      cart_item_count: cart.item_count,
      cart_total: moneyFromCents(cart.total_price),
      cart_total_cents: cart.total_price,
      cart_currency: cart.currency,
    };
  }

  function productFromCard(button) {
    var card =
      (button && button.closest('.product-card')) ||
      (button && button.closest('.cart-upsell-card'));
    if (!card) {
      return {
        variant_id: button && Number(button.dataset.variantId),
      };
    }
    var titleEl =
      card.querySelector('.product-card__title') ||
      card.querySelector('.cart-upsell-card__title');
    return {
      product_id: card.getAttribute('data-product-id')
        ? Number(card.getAttribute('data-product-id'))
        : undefined,
      product_handle: card.getAttribute('data-product-handle') || undefined,
      product_title: titleEl ? titleEl.textContent.trim() : undefined,
      product_price: moneyFromCents(card.getAttribute('data-price')),
      variant_id: button && Number(button.dataset.variantId),
      source: card.classList.contains('cart-upsell-card') ? 'upsell' : 'product_card',
    };
  }

  /* —— Page-level views —— */
  function trackInitialViews() {
    var ctx = (window.BricksartPostHog && window.BricksartPostHog.context) || {};

    if (ctx.product_id) {
      capture('product_viewed', {
        product_id: ctx.product_id,
        product_handle: ctx.product_handle,
        product_title: ctx.product_title,
        product_type: ctx.product_type,
        product_vendor: ctx.product_vendor,
        product_price: moneyFromCents(ctx.product_price),
        product_available: ctx.product_available,
      });
    }

    if (ctx.collection_id) {
      capture('collection_viewed', {
        collection_id: ctx.collection_id,
        collection_handle: ctx.collection_handle,
        collection_title: ctx.collection_title,
        collection_products_count: ctx.collection_products_count,
      });
    }

    if (ctx.search_query) {
      capture('search_submitted', {
        search_query: ctx.search_query,
        search_results_count: ctx.search_results_count,
        source: 'page',
      });
    }

    if (ctx.page_type === 'cart' || ctx.template === 'cart') {
      capture('cart_viewed', {
        cart_item_count: ctx.cart_item_count,
        cart_total: moneyFromCents(ctx.cart_total),
        source: 'page',
      });
    }
  }

  /* —— Cart —— */
  var lastCartItemCount = null;

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;

    var summary = cartSummary(cart);
    var prev = lastCartItemCount;
    lastCartItemCount = cart.item_count;

    capture('cart_updated', summary);

    if (prev != null && cart.item_count === 0 && prev > 0) {
      capture('cart_emptied', summary);
    }

    if (event.detail && event.detail.attemptedDiscount != null) {
      var code = String(event.detail.attemptedDiscount || '').trim();
      capture(code ? 'discount_applied' : 'discount_removed', Object.assign({
        discount_code: code || undefined,
      }, summary));
    }
  });

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest(
      'a[href*="/checkout"], .cart-drawer__checkout a, a.cart-drawer__checkout'
    );
    if (!checkout) return;
    if (!checkout.closest('[data-cart-drawer-body]') && !checkout.closest('.section-main-cart')) {
      if (!/\/checkout\/?$/.test(checkout.getAttribute('href') || '')) return;
    }

    var ctx = (window.BricksartPostHog && window.BricksartPostHog.context) || {};
    capture('checkout_started', {
      cart_item_count: ctx.cart_item_count,
      cart_total: moneyFromCents(ctx.cart_total),
      source: checkout.closest('[data-cart-drawer-body]') ? 'cart_drawer' : 'cart_page',
    });
  });

  /* —— Drawers —— */
  document.addEventListener('drawer:opened', function (event) {
    var id = event.detail && event.detail.id;
    capture('drawer_opened', { drawer_id: id });
    if (id === 'CartDrawer' || id === 'cart') {
      var ctx = (window.BricksartPostHog && window.BricksartPostHog.context) || {};
      capture('cart_viewed', {
        cart_item_count: ctx.cart_item_count,
        cart_total: moneyFromCents(ctx.cart_total),
        source: 'drawer',
      });
    }
  });

  document.addEventListener('drawer:closed', function (event) {
    capture('drawer_closed', {
      drawer_id: event.detail && event.detail.id,
    });
  });

  /* —— Modals —— */
  document.addEventListener('modal:opened', function (event) {
    var id = event.detail && event.detail.id;
    var source = event.detail && event.detail.source;
    capture('modal_opened', { modal_id: id, source: source });
    if (id && /newsletter/i.test(id)) {
      capture('newsletter_modal_opened', { modal_id: id, source: source });
    }
  });

  document.addEventListener('modal:closed', function (event) {
    capture('modal_closed', {
      modal_id: event.detail && event.detail.id,
    });
  });

  /* —— Forms —— */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    if (form.querySelector('[data-customer-form-context="newsletter"]') ||
        form.querySelector('[data-newsletter-subscribed]') ||
        (form.getAttribute('id') || '').toLowerCase().indexOf('newsletter') !== -1) {
      capture('newsletter_subscribed', { source: 'form_submit' });
      return;
    }

    if (form.getAttribute('accept-charset') != null && form.querySelector('[name="contact[email]"]')) {
      var isContact =
        form.querySelector('[name="contact[body]"]') ||
        form.querySelector('[name="contact[message]"]') ||
        form.action && form.action.indexOf('/contact') !== -1;
      if (isContact) {
        capture('contact_form_submitted', {});
      }
    }
  });

  if (document.querySelector('[data-newsletter-subscribed]')) {
    capture('newsletter_subscribed', { source: 'success_marker' });
  }

  /* —— Product card ATC success (dispatched from product-card.js) —— */
  document.addEventListener('analytics:product_added', function (event) {
    var detail = event.detail || {};
    capture(
      'product_added_to_cart',
      Object.assign({}, detail, cartSummary(detail.cart))
    );
  });

  document.addEventListener('analytics:product_removed', function (event) {
    var detail = event.detail || {};
    capture(
      'product_removed_from_cart',
      Object.assign({}, detail, cartSummary(detail.cart))
    );
  });

  document.addEventListener('analytics:quantity_changed', function (event) {
    var detail = event.detail || {};
    capture(
      'cart_quantity_changed',
      Object.assign({}, detail, cartSummary(detail.cart))
    );
  });

  document.addEventListener('analytics:variant_selected', function (event) {
    capture('product_variant_selected', event.detail || {});
  });

  document.addEventListener('analytics:bundle_selected', function (event) {
    capture('product_bundle_selected', event.detail || {});
  });

  document.addEventListener('analytics:multibuy_selected', function (event) {
    capture('product_multibuy_selected', event.detail || {});
  });

  document.addEventListener('analytics:search', function (event) {
    capture('search_submitted', event.detail || {});
  });

  document.addEventListener('analytics:collection_sorted', function (event) {
    capture('collection_sorted', event.detail || {});
  });

  document.addEventListener('analytics:gift_card', function (event) {
    capture('gift_card_action', event.detail || {});
  });

  /* —— FAQ / accordions —— */
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (!el || el.tagName !== 'DETAILS') return;
    if (!el.open) return;
    var title = el.querySelector('summary');
    capture('faq_opened', {
      question: title ? title.textContent.trim().slice(0, 200) : undefined,
    });
  }, true);

  /* —— Outbound / account —— */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('account.bricks-art.com') !== -1) {
      capture('account_clicked', { href: href });
    }
  });

  /* —— Expose helper for ATC without custom event —— */
  window.BricksartAnalytics.productFromCard = productFromCard;

  var booted = false;

  function boot() {
    if (booted) return;
    if (!ph()) return;
    booted = true;

    var ctx = (window.BricksartPostHog && window.BricksartPostHog.context) || {};
    if (typeof ctx.cart_item_count === 'number') {
      lastCartItemCount = ctx.cart_item_count;
    }
    trackInitialViews();
  }

  document.addEventListener('posthog:ready', boot, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
